import React, { useReducer, useState, useEffect } from "react";
import Input from "../../../../Input/Input.jsx";
import CustomButton from "../../../../Button/CustomButton.tsx";
import { useAuth } from "../../../../../context/AuthContext.jsx";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { StyledModalcomponentMuestras } from "../../../Styled.jsx";
import { getClienteOptions } from "../../../../../api/Clientes.js";
import { colors, fonts } from "../../../../../assets/styles/theme.ts";
import {
  getAllConjuntoAnalisis,
  getAllPuntoTomasByCliente,
  getAllLubricante,
  createMuestra,
  updateMuestra,
  getAllPuntoTomasOptionsClienteOptions,
  getAllOrdenTrabajoOptions,
} from "../../../../../api/Muestras.js";
import { getAllOrdenByClienteOptionMuestras } from "../../../../../api/Muestras.ts";
import { getOtOptionsPuntoDeToma } from "../../../../../api/EndPoints.ts";
import Preloader from "../../../../Preloader/Preloader.jsx";
import Toast from "../../../../Toast/Toast.jsx";

import dayjs from "dayjs";
import 'dayjs/locale/es';
import styled from "styled-components";
dayjs.locale('es');

const MuestrasModal = (props) => {
  const { token } = useAuth();

  const propsMuestras = (datosUnidades) => {
    const ver = datosUnidades?.button === "ver" ?? false;
    const editar = datosUnidades?.button === "editar" ?? false;
    const datos = datosUnidades?.datos ?? [];
    return { ver, editar, datos };
  };
  const { cliente, orden, button } = props.datos || {};
  const fromNuevaMuestra = button === "crear";

  const { ver, editar, datos } = propsMuestras(props.datos);
  const [formCompleto, setFormCompleto] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [msjToast, setMsjToast] = useState("");
  const [clientes, setClientes] = useState([]);
  const [ordenes, setOrdenes] = useState([]);
  const [puntosTomas, setPuntosTomas] = useState([]);
  const [conjuntos, setConjuntos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOptioncli, setSelectedOptioncli] = useState(null);
  const [selectedOptionorden, setSelectedOptionorden] = useState(null);
  const [selectedOptionptoma, setSelectedOptionptoma] = useState(null);
  const [selectedOptioncon, setSelectedOptioncon] = useState([]);
  const [selectedOptionlub, setSelectedOptionlub] = useState(null);
  const [selectedOptionlubStepDos, setSelectedOptionlubStepDos] = useState(null);
  const [menuIsOpenPuntoDeToma, setmenuIsOpenPuntoDeToma] = useState(false);
  const [lubricantes, setLubricantes] = useState([]);
  const [lubricantesStepDos, setLubricantesStepDos] = useState([]);
  const [stepDos, setStepDos] = useState(false);
  const [muestrasCreadas, setMuestrasCreadas] = useState(0);


  const [form, setForm] = useReducer(
    (state, action) => {
      switch (action.type) {
        case "SET_FIELD":
          return { ...state, [action.field]: action.value };
        default:
          return state;
      }
    },
    {
      id: datos.id ?? "",
      codigo: datos.codigo ?? "",
      lote: datos.lote ?? "",
      denominacion: datos.denominacion ?? "",
      cliente: token.clienteId !== ""
        ? parseInt(token.clienteId, 10)
        : datos.cliente
          ? datos.cliente
          : "",
      clienteDesc: datos.clienteDesc ?? "",
      planta: datos.planta ?? "",
      estado: datos.estado ?? "",
      fecha: datos.fechaTomaMue ? dayjs(datos.fechaTomaMue) : null,
      punto: datos.punto ?? "",
      lubSugerido: datos.lubSugerido ?? "",
      horasUso: datos.horasUso ?? "",
      lubricante: datos.lubricante ?? "",
      horasusoLubricante: datos.horasUsoLubricante ?? "",
      responsable: datos.responsable ?? "",
      ordenTrabajoComp: datos.ordenTrabajo ?? "",
      conjuntoComp: datos.conjunto ?? "",
      puntoTomaComp: datos.puntoToma ?? "",
      conjunto: datos.conjunto?.id ?? "",
      horaUsoEquipoStepDos: "",
      horasLubricanteStepDos: "",
      denominacionStepDos: "",
      lubricanteStepDos: "",
    }
  );

  useEffect(() => {
    const campoValido = (campo) => form[campo] !== null && form[campo] !== "";
    const camposaValidar = [
      "fecha",
      "orden",
      "punto",
      "cliente",
      "conjunto",
      "responsable",
    ];
    const formularioCompleto = camposaValidar.every(campoValido);
    setFormCompleto(formularioCompleto);
  }, [form]);

  useEffect(() => {
    fetchclientesAndOrden();
    fetchConjuntos();
    fetchLubricantes();

    if (editar || ver) {
      fetchPuntosTomas();
    }
  }, []);

  useEffect(() => {
    fetchConjuntos();
    fetchLubricantes();
    if (editar || ver) {
      fetchPuntosTomas();
      fetchclientesAndOrden();
    }
    else if (fromNuevaMuestra && cliente?.value) {
      getAllOrdenByClienteOptionMuestras(selectedOptioncli?.value ?? cliente?.value).then((res) => {
        const ordenesMap = res.data.map((o) => ({
          value: o.id,
          label: `${o.desc_otra} #${o.nro_lote_otra}`,
          subLabel: o.estado.desc_ef_ot,
          code: o.codigo_otra,
          color: o.estado.color_ef_ot
        }));
        setOrdenes(ordenesMap);
      });
      getAllPuntoTomasByCliente(cliente.value).then((res) => {
        const puntosMap = res.data.map((pto) => ({
          label: `${pto.desc_pto}`,
          code: pto.codigo_pto,
          subLabel: `${pto.equipo.tag_planta}-${pto.equipo.denominacion}`,
          value: pto.id,
          lub: pto.desc_lub,
        }));
        setPuntosTomas(puntosMap);
      });
    }
    else {
      fetchclientesAndOrden();
    }
  }, [editar, ver, fromNuevaMuestra, cliente]);

  useEffect(() => {
    if (cliente?.value) {
      setSelectedOptioncli(cliente);
      setForm({ type: "SET_FIELD", field: "cliente", value: cliente.value });
    }
    if (orden?.value) {
      setSelectedOptionorden(orden);
      setForm({ type: "SET_FIELD", field: "orden", value: orden.value });
    }
  }, [cliente, orden]);



  const fetchConjuntos = async () => {
    const res = await getAllConjuntoAnalisis();
    const unidades = res?.data?.map((item) => ({
      value: item.id,
      label: item.desc_cana,
    }));
    setConjuntos(unidades);

    if (datos) {
      const matchOption = unidades.find(
        (option) => option.value === form.conjunto
      );
      if (matchOption) {
        setSelectedOptioncon(matchOption);
      } else if (unidades.length > 0 && editar) {
        setSelectedOptioncon(unidades[0]);
      }
    } else if (unidades.length > 0 && editar) {
      setSelectedOptioncon(unidades[0]);
    }
  };

  const fetchLubricantes = async () => {
    const res = await getAllLubricante();
    const unidades = res?.data?.map((item) => ({
      value: item.id,
      code: item.codigo_lub,
      label: item.desc_lub,
    }));
    setLubricantes(unidades);
    setLubricantesStepDos(unidades);

    if (datos) {
      const matchOption = unidades.find(
        (option) => option.label === datos.lubricante?.description
      );
      if (matchOption) {
        setSelectedOptionlub(matchOption);
        setSelectedOptionlubStepDos(matchOption);
      } else if (unidades.length > 0 && editar) {
        setSelectedOptionlub(unidades[0]);
        setSelectedOptionlubStepDos(unidades[0]);
      }
    } else if (unidades.length > 0 && editar) {
      setSelectedOptionlub(unidades[0]);
      setSelectedOptionlubStepDos(unidades[0]);
    }
  };

  const fetchclientesAndOrden = async () => {
    const res = await getClienteOptions();
    const allCLientes = res?.data?.map((item) => ({
      value: item.id,
      label: item.desc_cli,
    }));
    setClientes(allCLientes);

    if (token.clienteId !== "") {

      const matchOption = allCLientes.find(
        (option) => option.value === parseInt(token.clienteId, 10)
      );

      if (matchOption) {
        setSelectedOptioncli(matchOption)

        getAllOrdenTrabajoOptions(matchOption.value).then((res) => {
          if (res.data.length !== 0) {
            setOrdenes(
              res.data.map((res) => {
                // const labelOrden = `Orden ${res.id} - ${res.desc_otra} - (${res.nro_lote_otra})`;

                if (form.ordenTrabajoComp?.desc_otra === res.desc_otra) {
                  setSelectedOptionorden({

                    value: res.id,
                    label: `${res.desc_otra} #${res.nro_lote_otra}`,
                    subLabel: res.estado.desc_ef_ot,
                    code: res.codigo_otra,
                    color: res.estado.color_ef_ot
                  });
                }

                return {
                  value: res.id,
                  label: `${res.desc_otra} #${res.nro_lote_otra}`,
                  subLabel: res.estado.desc_ef_ot,
                  code: res.codigo_otra,
                  color: res.estado.color_ef_ot
                };
              })
            );
          }
        });

        getAllPuntoTomasOptionsClienteOptions(matchOption.value).then((res) => {
          // getAllPuntoTomasOptionsClienteOptions
          if (res.data.length !== 0) {
            setPuntosTomas(
              res.data.map((res) => {

                if (form.puntoTomaComp.desc_pto === res.desc_pto) {
                  setSelectedOptionptoma({
                    label: `${res.desc_pto}`,
                    code: res.codigo_pto,
                    subLabel: `${res.equipo.tag_planta}-${res.equipo.denominacion}`,
                    value: res.id,
                    lub: res.lubricante,
                  });
                  clearEditables();
                }
                if (res.lubricante && res.lubricante.id && res.lubricante.description) {
                  // setForm({
                  //   type: "SET_FIELD",
                  //   field: "lubSugerido",
                  //   value: {
                  //     label: res.desc_lub.description,
                  //     value: res.desc_lub.id,
                  //   },
                  // });
                }

                return {
                  label: `${res.desc_pto}`,
                  code: res.codigo_pto,
                  subLabel: `${res.equipo.tag_planta}-${res.equipo.denominacion}`,
                  value: res.id,
                  lub: res.lubricante,
                };
              })
            );
          }
        });
      }
    } else {
      if (datos && !Array.isArray(datos)) {
        const matchOption = allCLientes.find(
          (option) => option.value === datos.cliente
        );

        if (matchOption) {
          setSelectedOptioncli(matchOption);
          getAllOrdenTrabajoOptions(matchOption.value).then((res) => {
            if (res.data.length !== 0) {
              setOrdenes(
                res.data.map((res) => {

                  if (form.ordenTrabajoComp.desc_otra === res.desc_otra) {
                    setSelectedOptionorden({
                      value: res.id,
                      label: `${res.desc_otra} #${res.nro_lote_otra}`,
                      subLabel: res.estado.desc_ef_ot,
                      code: res.codigo_otra,
                      color: res.estado.color_ef_ot
                    });
                  }
                  return {
                    value: res.id,
                    label: `${res.desc_otra} #${res.nro_lote_otra}`,
                    subLabel: res.estado.desc_ef_ot,
                    code: res.codigo_otra,
                    color: res.estado.color_ef_ot
                  };
                })
              );
            }
          });

          getAllPuntoTomasOptionsClienteOptions(matchOption.value).then((res) => {
            if (res.data.length !== 0) {
              setPuntosTomas(
                res.data.map((res) => {

                  if (form.puntoTomaComp.desc_pto === res.desc_pto) {
                    setSelectedOptionptoma({

                      label: `${res.desc_pto}`,
                      code: res.codigo_pto,
                      subLabel: `${res.equipo.tag_planta}-${res.equipo.denominacion}`,
                      value: res.id,
                      lub: res.lubricante,
                    });
                    clearEditables();
                  }
                  if (res.lubricante && res.lubricante.id && res.lubricante.description) {
                    // setForm({
                    //   type: "SET_FIELD",
                    //   field: "lubSugerido",
                    //   value: {
                    //     label: res.desc_lub.description,
                    //     value: res.desc_lub.id,
                    //   },
                    // });
                  }

                  return {
                    label: res.desc_pto,
                    value: res?.id,
                    lub: res.lubricante,
                  };
                })
              );
            }
          });
        } else {
          // allCLientes.push({ label: datos.clienteDesc, value: datos.cliente, estado: "eliminado" });
          allCLientes.push({
            label: datos.clienteDesc, value: datos.cliente,

          });

          setSelectedOptioncli({ label: datos.clienteDesc, value: datos.cliente });
          setSelectedOptionorden({ label: datos.ordenTrabajo.desc_otra ?? datos.ordenTrabajo.description, value: datos.ordenTrabajo.id });
        }
      }
    }


  };

  const handleChange = (e, nameReactSelect) => {
    if (e.target) {
      const { name, value, checked, type } = e.target;
      const fieldValue = type === "checkbox" ? checked : value;
      setForm({ type: "SET_FIELD", field: name, value: fieldValue });
    } else {
      const value = e.value;
      const name = nameReactSelect;

      if (name === "cliente") {
        setSelectedOptioncli(e);
        setForm({ type: "SET_FIELD", field: name, value: value });
      } else if (name === "punto") {

        setSelectedOptionptoma(e);
        setForm({ type: "SET_FIELD", field: name, value: value });
        clearEditables();

      } else if (name === "conjunto") {

        setSelectedOptioncon(e);
        setForm({ type: "SET_FIELD", field: name, value: value });
      } else if (name === "lubricante") {
        setSelectedOptionlub(e);
        setForm({ type: "SET_FIELD", field: name, value: value });
      }
      else if (name === "lubricanteStepDos") {
        setSelectedOptionlubStepDos(e);
        setForm({ type: "SET_FIELD", field: name, value: value });
      }
    }
  };

  const fetchPuntosTomas = async () => {
    if (datos) {
      let auxpto = {
        value: datos.puntoToma?.id,
        label: datos.puntoToma?.description,
      };
      let auxOrden = {
        value: datos.ordenTrabajo?.id,
        label: datos.ordenTrabajo?.description,
      };
      let auxConjunto = {
        value: datos.conjunto.id,
        label: datos.conjunto.description,
      };
      let auxLubricante = {
        value: datos.lubricante.id,
        label: datos.lubricante.description,
      };

      setSelectedOptionptoma(auxpto);
      setForm({ type: "SET_FIELD", field: "punto", value: auxpto.value });
      setPuntosTomas([auxpto]);
      clearEditables();

      setSelectedOptionorden(auxOrden);
      setForm({ type: "SET_FIELD", field: "orden", value: auxOrden.value });
      setOrdenes([auxOrden]);

      setSelectedOptioncon(auxConjunto);
      setForm({
        type: "SET_FIELD",
        field: "conjunto",
        value: auxConjunto.value,
      });
      setConjuntos([auxConjunto]);

      setSelectedOptionlub(auxLubricante);
      setSelectedOptionlubStepDos(auxLubricante);
      setForm({
        type: "SET_FIELD",
        field: "lubricante",
        value: auxLubricante.value,
      });
      setLubricantes([auxLubricante]);
      setLubricantesStepDos([auxLubricante]);
    }
  };

  const clearEditables = () => {
    // Limpiar campos del primer paso
    setForm({ type: "SET_FIELD", field: "horasUso", value: "" });
    setForm({ type: "SET_FIELD", field: "horasusoLubricante", value: "" });
    setForm({ type: "SET_FIELD", field: "denominacion", value: "" });
    
    // Limpiar campos del stepDos
    setForm({ type: "SET_FIELD", field: "horaUsoEquipoStepDos", value: "" });
    setForm({ type: "SET_FIELD", field: "horasLubricanteStepDos", value: "" });
    setForm({ type: "SET_FIELD", field: "denominacionStepDos", value: "" });
    
    // Limpiar lubricantes seleccionados
    setForm({ type: "SET_FIELD", field: "lubricante", value: null });
    setForm({ type: "SET_FIELD", field: "lubricanteStepDos", value: null });
    setSelectedOptionlub(null);
    setSelectedOptionlubStepDos(null);
  }

  const clearLubricanteSugerido = () => {
    setForm({ type: "SET_FIELD", field: "lubSugerido", value: { label: "", value: "" } });
  }

  const handleChangeCliente = (e) => {
    setSelectedOptionorden(null);
    setOrdenes([]);
    setSelectedOptionlub(null);
    setSelectedOptionlubStepDos(null);
    setForm({ type: "SET_FIELD", field: "orden", value: "" });

    setSelectedOptionptoma(null);
    setPuntosTomas([]);
    setForm({ type: "SET_FIELD", field: "punto", value: "" });
    clearEditables();
    clearLubricanteSugerido();

    setSelectedOptioncli(e);
    setForm({ type: "SET_FIELD", field: "cliente", value: e.value });

    if (!e?.value) return;

    getAllOrdenByClienteOptionMuestras(e.value).then((res) => {
      setOrdenes(
        res.data.map((res) => ({
          value: res.id,
          label: `${res.desc_otra} #${res.nro_lote_otra}`,
          subLabel: res.estado.desc_ef_ot,
          code: res.codigo_otra,
          color: res.estado.color_ef_ot
        }))
      );
    });

    // getAllPuntoTomasByCliente(e.value).then((res) => {
    //   setPuntosTomas(
    //     res.data.map((res) => ({
    //       // label: `${res.desc_pto} (${res.codigo_pto})`,
    //       label: `${res.desc_pto}`,
    //       code: res.codigo_pto,
    //       subLabel: `${res.equipo.tag_planta}-${res.equipo.denominacion}`,
    //       value: res.id,
    //       lub: res.desc_lub,
    //     }))
    //   );
    // });
  };

  const handleChangePunto = (e) => {

    setSelectedOptionptoma(e);
    setForm({ type: "SET_FIELD", field: "punto", value: e.value });

    // Limpiar todos los campos editables cuando se cambia el punto de toma
    clearEditables();

    // Actualizar el lubricante sugerido basado en el punto seleccionado
    if (e.lub !== null) {
      setForm({
        type: "SET_FIELD",
        field: "lubSugerido",
        value: { label: e.lub?.description, value: e.lub?.id },
      });
    }

  };

  const handleChangeOrden = (e) => {
    setSelectedOptionorden(e);
    setForm({ type: "SET_FIELD", field: "orden", value: e.value });
    
    // Limpiar punto de toma y lubricante sugerido cuando se cambia la orden
    setSelectedOptionptoma(null);
    setForm({ type: "SET_FIELD", field: "punto", value: "" });
    clearLubricanteSugerido();
    clearEditables();
    
    if (e?.value) {
      getOtOptionsPuntoDeToma(e.value).then((res) => {
        setPuntosTomas(
          res.data.map((pto) => ({
            label: `${pto.desc_pto}`,
            code: pto.codigo_pto,
            subLabel: `${pto.equipo.tag_planta}-${pto.equipo.denominacion}`,
            value: pto.id,
            lub: pto.lubricante,
          }))
        );
      });
    } else {
      setPuntosTomas([]);
      setSelectedOptionptoma(null);
    }
  };
  const handleChangeCalendar = (e, nameCalendar) => {
    const name = nameCalendar;
    setForm({ type: "SET_FIELD", field: name, value: e });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setmenuIsOpenPuntoDeToma(false);
    // Determine lubricante_id based on conditions
    let lubricanteId;
    if (stepDos) {
      if (form.lubricanteStepDos === null || form.lubricanteStepDos === "") {
        lubricanteId = form.lubSugerido.value;
      } else {
        lubricanteId = form.lubricanteStepDos;
      }
    } else if (form.lubricante === null || form.lubricante === "") {
      lubricanteId = form.lubSugerido.value;
    } else {
      lubricanteId = form.lubricante.id || form.lubricante;
    }

    let formattedData = {
      desc_mue: stepDos ? form.denominacionStepDos : form.denominacion,
      fecha_toma_mue: form.fecha,
      horas_lubricante_mue: stepDos ? form.horasLubricanteStepDos : form.horasusoLubricante,
      horas_equipo_mue: stepDos ? form.horaUsoEquipoStepDos : form.horasUso,
      punto_toma_id: parseInt(form.punto),
      lubricante_id: parseInt(lubricanteId),
      responsable_toma_mue: form.responsable,
      conjunto_analisis_id: parseInt(form.conjunto),
      orden_trabajo_id: parseInt(form.orden),
      status: "SI",
    };

    if (editar) {
      formattedData.id = form.id;
      await updateMuestra(formattedData)
        .then((res) => {
          setIsLoading(false);
          props.onClick({
            msj: "Muestra modificada con exito.",
            status: "success",
          });
        })
        .catch((err) => {
          setIsLoading(false);
          props.onClick({
            msj: "No se Pudo modificar la Muestra.",
            status: "error",
          });
        });
    } else {
      await createMuestra(formattedData)
        .then((res) => {
          setIsLoading(false);
          setStepDos(true);
          setSuccess(true);
          setMsjToast(`Se creó la muestra número: ${res.data}`);
          setmenuIsOpenPuntoDeToma(true)
          setMuestrasCreadas(prev => prev + 1);
          
          // Actualizar los puntos de toma para obtener datos frescos después de crear una muestra
          if (form.orden) {
            getOtOptionsPuntoDeToma(form.orden).then((res) => {
              const puntosActualizados = res.data.map((pto) => ({
                label: `${pto.desc_pto}`,
                code: pto.codigo_pto,
                subLabel: `${pto.equipo.tag_planta}-${pto.equipo.denominacion}`,
                value: pto.id,
                lub: pto.lubricante,
              }));
              setPuntosTomas(puntosActualizados);
              
              // Encontrar el punto actual en los datos actualizados
              const puntoActual = puntosActualizados.find(pto => pto.value === form.punto);
              if (puntoActual) {
                // Actualizar el lubricante sugerido con los datos frescos del punto
                if (puntoActual.lub !== null) {
                  setForm({
                    type: "SET_FIELD",
                    field: "lubSugerido",
                    value: { label: puntoActual.lub?.description, value: puntoActual.lub?.id },
                  });
                }
              }
            });
          }

          // Resetear el lubricante seleccionado para que use el sugerido
          setForm({
            type: "SET_FIELD",
            field: "lubricanteStepDos",
            value: null
          });
          setSelectedOptionlubStepDos(null);
        })
        .catch((err) => {
          setIsLoading(false);
          props.onClick({
            msj: "No se pudo crear la Muestra.",
            status: "error",
          });
        });
    }
  };

  const handleClose = () => {
    // Si se crearon muestras durante esta sesión, indicar que se debe volver a la página 1
    if (muestrasCreadas > 0) {
      props.onClick({
        msj: "Muestras creadas exitosamente",
        status: "success",
      });
    } else {
      props.onClick({
        msj: "",
        status: "cancel",
      });
    }
    setStepDos(false);
    setmenuIsOpenPuntoDeToma(false);
    setMuestrasCreadas(0); // Resetear el contador
  }
  const renderButtons = () => {
    return (
      <>
        <CustomButton
          onClick={() => { handleClose() }}
          label="Cancelar"
          variant="contained"
          className={"buttonColorDisabled"}
        />

        {!ver && (
          <CustomButton
            label={"Confirmar"}
            variant="contained"
            className={`buttonColorDefault btn`}
            type="submit"
            disabled={!selectedOptioncli || !selectedOptionorden || !formCompleto || (selectedOptioncli.estado && selectedOptioncli.estado === "eliminado")}
          />
        )}
      </>
    );
  };

  const titulo = () => {
    const titulo = ver ? "Ver muestras" : "Crear o editar muestras";
    return titulo;
  };

  return (
    <StyledModalcomponentMuestras
      sx={{
        width: "70%",
        overflowY: "auto",
        height: "85%",
        "@media (max-width: 768px)": {
          width: "95%",
          overflowY: "auto",
          height: "70%",
        },
      }}
    >
      
      <Preloader
        title="Cargando..."
        subtitle={"Espere unos Segundos por favor..."}
        loading={isLoading}
      />

      <ToastDiv >

        {success ?
          <Toast
            title={msjToast}
            close={() => setSuccess(false)}
            type={"success"}
            timeClose={2000}
          />
          : null}
        {error ? (
          <Toast
            type={"error"}
            title={
              "Error al " + (editar ? "modificar" : "crear") + "la orden ?"
            }
            close={() => setError(false)}
          />
        ) : null}
      </ToastDiv>

      <div className="muestras">
        <div className="divLabel">
          <p className="titulo"> {titulo()} </p>
        </div>
        {stepDos === false ?
          <form className="formulario" onSubmit={handleSubmit}>
            {(editar || ver) && (
              <div className="divNumeroMuestra">
                <p className="titleNumeroMuestra"> Número de la muestra</p>
                <div className="divBodyNumeroMuestra">
                  <p className="labelNumeroMuestra">{form.codigo ?? ""}</p>
                </div>
              </div>
            )}

            <div className="columna">
              <div className="a">
                <div className="aa">
                  <Input
                    isLoading={selectedOptioncli === null && editar}
                    reactSelect
                    options={clientes}
                    value={selectedOptioncli}
                    onChange={(e) => {
                      handleChangeCliente(e, "cliente");
                    }}
                    isDisabled={ver || fromNuevaMuestra || token.clienteId !== ""}
                    placeholder={
                      token.clienteId !== "" ? "Cliente" :
                        selectedOptioncli ? "Cliente" : "Seleccione el cliente"
                    }
                  />
                  {!ver && selectedOptioncli && selectedOptioncli.estado === "eliminado" ?
                    <p className="p-0 m-0 "
                      style={{ margin: "0px", fontStyle: "italic", fontWeight: "bold", color: "red" }}>
                      **cliente eliminado, elegir otro**
                    </p>
                    :
                    null}
                </div>
                <div className="aa">
                  <Input
                    isLoading={selectedOptionorden === null && editar}
                    reactSelect
                    options={ordenes}
                    value={selectedOptionorden ?? ""}
                    onChange={(e) => {
                      handleChangeOrden(e, "orden");
                    }}
                    isDisabled={ver ||
                      selectedOptioncli?.estado === "eliminado" ||
                      fromNuevaMuestra}
                    placeholder={
                      ver || editar || selectedOptionorden ? "Orden de trabajo" : "Seleccione la orden de Trabajo"
                    }
                    showSubLabel
                  />
                  {!ver && selectedOptioncli && selectedOptioncli.estado === "eliminado" ? <p className="p-0 m-0 " style={{ margin: "0px", fontStyle: "italic", fontWeight: "bold", color: "red" }}>**orden eliminada, elegir cliente**</p> : null}
                </div>
              </div>
              <div className="b">

                <Input
                  isLoading={selectedOptionptoma === null && editar}
                  reactSelect
                  options={puntosTomas}
                  value={menuIsOpenPuntoDeToma === true ? null : selectedOptionptoma}
                  onChange={(e) => {
                    handleChangePunto(e, "punto");
                    
                  }}
                  isDisabled={ver || !selectedOptionorden}
                  placeholder={
                    selectedOptionptoma
                      ? "Punto de Toma"
                      : "Seleccione el punto de toma"
                  }
                  
                  showSubLabel
                />

                <Input
                  isLoading={selectedOptioncon === null && editar}
                  reactSelect
                  options={conjuntos}
                  value={selectedOptioncon}
                  onChange={(e) => {
                    handleChange(e, "conjunto");

                  }}
                  isDisabled={ver && true}
                  placeholder={
                    selectedOptioncon ? "Conjunto de Análisis" : "Seleccione el conjunto de análisis"
                  }
                />
              </div>
              <div className="c">
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                  <DemoContainer
                    components={["DatePicker", "DatePicker", "DatePicker"]}
                  >
                    <DatePicker
                      disabled={ver}
                      className="inputDate"
                      label="Fecha Toma de Muestra"
                      placeholder="Fecha Toma de Muestra"
                      value={form.fecha}
                      format="DD/MM/YYYY"
                      sx={{
                        "& .MuiInputBase-input": {
                          fontFamily: fonts.primary,
                          fontWeight: "400",
                          fontSize: "16px",
                          WebkitTextFillColor: "#163C5B",
                        },
                        "& .MuiFormLabel-root": {
                          fontFamily: fonts.primary,
                          fontWeight: "400",
                          fontSize: "16px",
                          WebkitTextFillColor: "#163C5B",
                        },
                        "& .MuiSvgIcon-root": {
                          color: "#163C5B",
                          WebkitTextFillColor: "#163C5B",
                        },
                      }}
                      slotProps={
                        <Input
                          className="input inputDate"
                          variant="outlined"
                          size={"medium"}

                        />
                      }
                      onChange={(e) => {
                        handleChangeCalendar(e, "fecha");
                      }}
                    // maxDate={dayjs()}
                    />
                  </DemoContainer>
                </LocalizationProvider>
                <Input
                  classnamediv="divInput"
                  className="input inputDescripcion"
                  label="Responsable Toma de Muestra"
                  name="responsable"
                  variant="outlined"
                  size={"medium"}
                  disabled={ver}
                  value={form.responsable}
                  onChange={handleChange}
                />
              </div>
              <div className="d">
                <Input
                  classnamediv="divInputL divInput"
                  className="input inputDescripcion"
                  label="Horas de uso de Equipo"
                  name="horasUso"
                  variant="outlined"
                  size={"medium"}
                  disabled={ver}
                  value={form.horasUso}
                  onChange={handleChange}
                />

                {!ver && (
                  <Input
                    value={form.lubSugerido.label}
                    label="Lubricante del Punto de Toma (sugerido)"
                    placeholder="Lubricante del Punto de Toma (sugerido)"
                    classnamediv="divInputL divInput"
                    className="input inputDescripcion"
                    variant="outlined"
                    size={"medium"}
                    name="lubSugerido"
                    disabled={true}
                    onChange={handleChange}
                    shrink
                  />
                )}
              </div>
              <div className="e">
                <Input
                  classnamediv="divInputL divInput"
                  className="input inputDescripcion"
                  label="Horas de uso de Lubricante"
                  name="horasusoLubricante"
                  variant="outlined"
                  size={"medium"}
                  disabled={ver}
                  value={form.horasusoLubricante}
                  onChange={handleChange}
                />

                <Input
                  classnamediv="divInputL divInput"
                  className="input inputDescripcion"
                  isLoading={selectedOptionlub === null && editar}
                  reactSelect
                  options={lubricantes}
                  value={selectedOptionlub}
                  onChange={(e) => {
                    handleChange(e, "lubricante");
                  }}
                  isDisabled={ver && true}
                  placeholder={
                    selectedOptionlub ? "Lubricante" : "Seleccione lubricante"
                  }
                  showSubLabel
                />
              </div>
              <div className="f">

                <Input
                  classnamediv="divInputL divInput"
                  className="input inputDescripcion"
                  label="Descripción"
                  name="denominacion"
                  variant="outlined"
                  size={"medium"}
                  disabled={ver}
                  value={form.denominacion}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="divButtonsItem">{renderButtons()}</div>
          </form>
          :
          <form className="formulario" onSubmit={handleSubmit}>
            <div className="columna">
              <div className="a">
                <div className="aa">
                  <Input
                    isLoading={selectedOptioncli === null && editar}
                    reactSelect
                    options={clientes}
                    value={selectedOptioncli}
                    onChange={(e) => {
                      handleChangeCliente(e, "cliente");
                    }}
                    isDisabled={ver || fromNuevaMuestra || token.clienteId !== ""}
                    placeholder={
                      token.clienteId !== "" ? "Cliente" :
                        selectedOptioncli ? "Cliente" : "Seleccione el cliente"
                    }
                  />
                  {selectedOptioncli && selectedOptioncli.estado === "eliminado" ? <p className="p-0 m-0 " style={{ margin: "0px", fontStyle: "italic", fontWeight: "bold", color: "red" }}>**cliente eliminado, elegir otro**</p> : null}
                </div>
                <div className="aa">
                  <Input
                    isLoading={selectedOptionorden === null && editar}
                    reactSelect
                    options={ordenes}
                    value={selectedOptionorden}
                    onChange={(e) => {
                      handleChangeOrden(e, "orden");
                    }}
                    isDisabled={ver ||
                      selectedOptioncli?.estado === "eliminado" ||
                      fromNuevaMuestra}
                    placeholder={
                      selectedOptionorden ? "Orden" : "Seleccione la orden"
                    }
                  />
                  {selectedOptioncli && selectedOptioncli.estado === "eliminado" ? <p className="p-0 m-0 " style={{ margin: "0px", fontStyle: "italic", fontWeight: "bold", color: "red" }}>**orden eliminada, elegir cliente**</p> : null}
                </div>
              </div>
              <div className="b">
                <Input
                  isLoading={selectedOptionptoma === null && editar}
                  reactSelect
                  options={puntosTomas}
                  value={selectedOptionptoma}
                  onChange={(e) => {
                    handleChangePunto(e, "punto");
                  }}
                  isDisabled={ver && true}
                  placeholder={
                    selectedOptionptoma
                      ? "Punto de toma"
                      : "Seleccione el punto de toma"
                  }
                  showSubLabel
                  showSelect={menuIsOpenPuntoDeToma}
                // onMenuClose={() => setmenuIsOpenPuntoDeToma(false)}
                // onMenuOpen={() => setmenuIsOpenPuntoDeToma(true)}
                />
                <Input
                  isLoading={selectedOptioncon === null && editar}
                  reactSelect
                  options={conjuntos}
                  value={selectedOptioncon}
                  onChange={(e) => {
                    handleChange(e, "conjunto");
                  }}
                  isDisabled={ver && true}
                  placeholder={
                    selectedOptioncon ? "Conjunto" : "Seleccione el conjunto"
                  }
                />
              </div>
              <div className="c">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer
                    components={["DatePicker", "DatePicker", "DatePicker"]}
                  >
                    <DatePicker
                      disabled={ver}
                      className="inputDate"
                      label="Fecha Toma de Muestra"
                      placeholder="Fecha Toma de Muestra"
                      value={form.fecha}
                      format="DD/MM/YYYY"
                      sx={{
                        '& .MuiInputBase-input.Mui-disabled': {
                          WebkitTextFillColor: '#163C5B',
                          color: '#163C5B',
                          opacity: 1,
                        },
                        '& .MuiInputBase-root.Mui-disabled': {
                          // backgroundColor: '#f8f7f7',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#ccc',
                        },
                        '& .MuiInputLabel-root.Mui-disabled': {
                          color: '#163C5B',
                        }
                      }}
                      slotProps={
                        <Input
                          className="input inputDate"
                          variant="outlined"
                          size={"medium"}

                        />
                      }
                      onChange={(e) => {
                        handleChangeCalendar(e, "fecha");
                      }}
                      maxDate={dayjs()}
                    />
                  </DemoContainer>
                </LocalizationProvider>
                <Input
                  classnamediv="divInput"
                  className="input inputDescripcion"
                  label="Responsable Toma de Muestra"
                  name="responsable"
                  variant="outlined"
                  size={"medium"}
                  disabled={ver}
                  value={form.responsable}
                  onChange={handleChange}
                />
              </div>
              <div className="d">
                <Input
                  classnamediv="divInputL divInput"
                  className="input inputDescripcion"
                  label="Horas de Uso de Equipo"
                  name="horaUsoEquipoStepDos"
                  variant="outlined"
                  size={"medium"}
                  disabled={ver}
                  value={form.horaUsoEquipoStepDos}
                  onChange={handleChange}
                />
                <Input
                  value={form.lubSugerido.label}
                  label="Lubricante del Punto de Toma (sugerido)"
                  placeholder="Lubricante del Punto de Toma (sugerido)"
                  classnamediv="divInputL divInput"
                  className="input inputDescripcion"
                  variant="outlined"
                  size={"medium"}
                  name="lubSugerido"
                  disabled={true}
                  onChange={handleChange}
                  shrink
                />
              </div>
              <div className="e">
                <Input
                  classnamediv="divInputL divInput"
                  className="input inputDescripcion"
                  label="Horas de Uso del Lubricante"
                  name="horasLubricanteStepDos"
                  variant="outlined"
                  size={"medium"}
                  value={form.horasLubricanteStepDos}
                  onChange={handleChange}
                />

                <Input
                  classnamediv="divInputL divInput"
                  className="input inputDescripcion"
                  isLoading={selectedOptionlubStepDos === null && editar}
                  reactSelect
                  options={lubricantesStepDos}
                  value={selectedOptionlubStepDos}
                  onChange={(e) => {
                    handleChange(e, "lubricanteStepDos");
                  }}
                  isDisabled={ver && true}
                  placeholder={selectedOptionlubStepDos ? "Lubricante" : "Seleccione lubricante"}
                />
              </div>
              <div className="f">
                <Input
                  classnamediv="divInputL divInput"
                  className="input inputDescripcion"
                  label="Descripcion"
                  name="denominacionStepDos"
                  variant="outlined"
                  size={"medium"}
                  disabled={ver}
                  value={form.denominacionStepDos}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="divButtonsItem">{renderButtons()}</div>
          </form>
        }
      </div>
    </StyledModalcomponentMuestras>
  );
};

export default MuestrasModal;

const ToastDiv = styled.div`
  & .MuiPaper-root {
    top: -2%;
    width: 98%;
    display: flex;
    align-items: center ;
    justify-content: center ;
    text-align: center;
    font-size: 18px;
  }
  & .MuiSnackbarContent-message{
    width: 90%;
    
  }

`;

